import { render, staticRenderFns } from "./annex-import-details.vue?vue&type=template&id=7454ed17&scoped=true"
import script from "./annex-import-details.vue?vue&type=script&lang=ts"
export * from "./annex-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454ed17",
  null
  
)

export default component.exports